const jQuery = window.jQuery;
require('bootstrap-loader');
require('../../scss/birmingham-meme.scss');

export { jQuery as $ };



// WEBPACK FOOTER //
// ./src/js/utils/tools.js